import StatusFilter from 'components/Participants/Filters/ParticipantStatus'
import ImportFilter from 'components/Participants/Filters/ParticipantImport'
import ParticipantTag from 'components/Participants/Filters/ParticipantTag'
import FilterByHub from 'components/Participants/Filters/FilterByHub'
import ProjectTag from 'components/Participants/Filters/ProjectTag'
import FilterByLastSeen from 'components/Participants/Filters/FilterByLastSeen/LastSeenFilterPill'
import FilterByJoinDate from 'components/Participants/Filters/FilterByJoinDate/JoinDateFilterPill'
import FilterBySuburbs from 'components/Participants/Filters/Suburbs'
import Email from 'components/Participants/Filters/Email/EmailFilterPill'
import ScreenName from 'components/Participants/Filters/ScreenName/ScreenNameFilterPill'
import FilterByProject from 'components/Participants/Filters/Project/ProjectAndEngagementPills'
import Location from 'components/Participants/Filters/Location'

export const Components: any = {
  FilterBySuburbs,
  FilterByLastSeen,
  FilterByJoinDate,
  ParticipantTag,
  FilterByHub,
  ProjectTag,
  StatusFilter,
  ImportFilter,
  Email,
  ScreenName,
  Location,
  FilterByProject, // Referencing the pills component here to show them once we update the filter
}
